import { render, staticRenderFns } from "./TranslationsForme.vue?vue&type=template&id=25caff94&scoped=true&"
import script from "./TranslationsForme.vue?vue&type=script&lang=js&"
export * from "./TranslationsForme.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsForme.vue?vue&type=style&index=0&id=25caff94&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25caff94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
